import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms'
import { Seatingplan, Event } from "../../../models";

@Component({
	selector: 'event-seatingplan-presentation',
	templateUrl: "./event-seatingplan.presentation.html"
})
export class EventSeatingplanPresentation {

	@Output() eventChange: EventEmitter<Event> = new EventEmitter<Event>();

	private _event: Event;
	private _seatingplans: Seatingplan[];

	private seatingplanForm: FormGroup;
	private data: Array<{ id: string, text: string }>;
	private seatingplanChanged: boolean = false;

	@Input()
	set event(event: Event) {
		if (event) {
			// wenn der event hier nicht kopiert wird, wird die seatingplan uuid im state angepasst sobald ein
			// anderer saalplan ausgewaehlt, oder der saalplan entfernt wurde
			this._event = Object.assign({}, event)
			this.createForm(this._event);
		}
	}


	@Input()
	set seatingplans(seatingplans: Seatingplan[]) {
		if (seatingplans && seatingplans.length > 0) {
			this._seatingplans = seatingplans
			this.data = this.createDataArray();
		}
	}

	public constructor (private formBuilder: FormBuilder, private changeDetectorRef: ChangeDetectorRef) {}

	public patchForm(event: Event) {
		this._event = Object.assign({}, event)
		this.seatingplanForm.controls['uuid'].setValue(event.seatingplanUuid, {onlySelf: false, emitEvent: true})
	}

	private createForm(event: Event) {
		this.seatingplanChanged = false
		this.seatingplanForm = this.formBuilder.group({
			uuid: event.seatingplanUuid
		})
		this.seatingplanForm.valueChanges.subscribe(data => {
			if (this._event.seatingplanUuid === data.uuid) {
				this.seatingplanChanged = false
			} else {
				this.seatingplanChanged = true
			}
			this.changeDetectorRef.markForCheck()
		})
	}

	private createDataArray() {
		return this._seatingplans.map(function(seatingplan){return{id: seatingplan.uuid, text: seatingplan.name}})
	}

	private submitSeatingplanFormData(seatingplanFormData: any) {
		let event: Event = this.editCopyOfEvent(seatingplanFormData.uuid)
		this.eventChange.emit(event);
	}

	private editCopyOfEvent(uuid: string) {
		return Object.assign(this._event, {seatingplanUuid: uuid})
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-seatingplan/event-seatingplan.presentation.ts